import { TFunction } from 'i18next';
import * as yup from 'yup';

import { translations } from 'locales/i18n';

export const bookingValidationSchema = (t: TFunction) =>
  yup.object().shape({
    article: yup.object().shape({
      id: yup
        .number()
        .required(t(translations.validation.required()))
        .typeError(t(translations.validation.required()))
        .label(t(translations.pages.leihbar.article.name()))
    }),
    startTime: yup
      .date()
      .required(t(translations.validation.required()))
      .typeError(t(translations.validation.required()))
      .label(t(translations.pages.leihbar.booking.columns.start())),
    endTime: yup
      .date()
      .required(t(translations.validation.required()))
      .typeError(t(translations.validation.required()))
      .label(t(translations.pages.leihbar.booking.columns.end()))
  });
